// Import Routes
import * as ROUTES from "../routes";

import REWARDS from '@/modules/rewards/views/rewards'
import COUPONS from '@/modules/rewards/views/coupon'
import PROMOS from '@/modules/rewards/views/promo'
import TUTORIALS from '@/modules/rewards/views/tutorials'
import ADD_BONUS from '@/modules/rewards/views/bonuses'
import BONUS  from '@/modules/rewards/views/view-bonus'
import BANNERS from '@/modules/rewards/views/banner'
import HOTTEST from '@/modules/rewards/views/hottest'
import TopTraders from '@/modules/dashboard/views/toptraders'
const routes = [
    {
        path: ROUTES.RANKING,
        name: "rewards",
        component: REWARDS,
        meta: {
            title: "Ranking System",
            layout: "private",
            requiresAuth: false,
            nav: 'Ranking',
            permissions: ['can_view_rewards']
        }
    },
    {
        path: ROUTES.PROMOTIONS,
        name: "promo",
        component: PROMOS,
        meta: {
            title: "promo code",
            layout: "private",
            requiresAuth: true,
            nav: 'Ranking',
            permissions: []
        }
    },{
        path: ROUTES.TOP_TRADERS,
        name: "traders",
        component: TopTraders,
        meta: {
            title: "Toptraders",
            layout: "private",
            requiresAuth: true,
            nav: 'top_traders'
        },
      
    },
    {
        path: ROUTES.COUPONS,
        name: "coupons",
        component: COUPONS,
        meta: {
            title: "coupon code",
            layout: "private",
            requiresAuth: true,
            nav: 'Ranking',
            permissions: []
        }
    },
    {
        path: ROUTES.TUTORIALS,
        name: "tutorials",
        component: TUTORIALS,
        meta: {
            title: "Tutorials",
            layout: "private",
            requiresAuth: true,
            nav: 'tutorials',
            permissions: []
        }
    },{
        path: ROUTES.BANNERS,
        name: "banners",
        component: BANNERS,
        meta: {
            title: "Banner",
            layout: "private",
            requiresAuth: true,
            nav: 'banners',
            permissions: []
        }
    },
    {
        path: ROUTES.HOTTEST,
        name: "hottest",
        component: HOTTEST,
        meta: {
            title: "Hottest Giftcards",
            layout: "private",
            requiresAuth: true,
            nav: 'tutorials',
            permissions: []
        }
    },
    {
        path: ROUTES.BONUSES,
        name: "bonuses",
        component: BONUS,
        meta: {
            title: "bonuses",
            layout: "private",
            requiresAuth: true,
            nav: 'bonuses',
            permissions: []
        }
    },
    {
        path: ROUTES.ADD_BONUS,
        name: "add_bonus",
        component: ADD_BONUS,
        meta: {
            title: "add bonuses",
            layout: "private",
            requiresAuth: true,
            nav: 'bonuses',
            permissions: []
        }
    }


]

export default routes;